import React from "react";
import Table from "../../table/Table";
import Score from "../../table/Score/Score";
import Options from "../../table/Options/Options";
import { Container } from "react-bootstrap";
function OneVsOneTable() {
  return (
    <Container className="tableTwo d-flex justify-content-center">
      {/*<img className="img-fluid" src={TableImage} alt="table" />*/}
      <Table />
      <Options />
      <Score />
      <div className="cards"></div>
    </Container>
  );
}

export default OneVsOneTable;
